module.exports = __webpack_public_path__ + "media/images/libra_sp-81b222bd476eed2771648b8e44426252.jpg";